import React from 'react';
import { ChevronLeft, MoreHorizontal } from 'lucide-react';
import BoardMenu from '../BoardMenu';
import styles from './KanbanBoardHeader.module.scss';

export interface KanbanBoardHeaderProps {
  boardTitle: string;
  editing: boolean;
  titleDraft: string;
  onBack: () => void;
  onTitleClick: () => void;
  onTitleChange: (value: string) => void;
  onTitleSubmit: () => void;
  onTitleCancel: () => void;
  menuTriggerRef: React.RefObject<HTMLButtonElement | null>;
  menuOpen: boolean;
  onMenuToggle: () => void;
  onMenuClose: () => void;
  archiveCount: number;
  showDeleteBoard: boolean;
  onChangeBackground: () => void;
  onChangeTextColor: () => void;
  onShowMembers: () => void;
  onShowArchived: () => void;
  onDeleteBoard: () => void;
}

export default function KanbanBoardHeader({
  boardTitle,
  editing,
  titleDraft,
  onBack,
  onTitleClick,
  onTitleChange,
  onTitleSubmit,
  onTitleCancel,
  menuTriggerRef,
  menuOpen,
  onMenuToggle,
  onMenuClose,
  archiveCount,
  showDeleteBoard,
  onChangeBackground,
  onChangeTextColor,
  onShowMembers,
  onShowArchived,
  onDeleteBoard,
}: KanbanBoardHeaderProps) {
  return (
    <div className={styles.header}>
      <div className={styles.headerLeft}>
        <button
          type="button"
          className={styles.backBtn}
          onClick={onBack}
          aria-label="Back to boards"
        >
          <ChevronLeft size={20} />
        </button>
        <div className={styles.titleWrap}>
          {editing ? (
            <input
              type="text"
              className={styles.titleInput}
              value={titleDraft}
              onChange={(e) => onTitleChange(e.target.value)}
              onBlur={() => void onTitleSubmit()}
              onKeyDown={(e) => {
                if (e.key === 'Enter') void onTitleSubmit();
                if (e.key === 'Escape') onTitleCancel();
              }}
              autoFocus
              aria-label="Board name"
            />
          ) : (
            <button
              type="button"
              className={styles.titleBtn}
              onClick={onTitleClick}
              aria-label="Edit board name"
            >
              <h1 className={styles.title}>{boardTitle}</h1>
            </button>
          )}
          <p className={styles.subtitle}>Drag and drop cards across lists</p>
        </div>
      </div>
      <div className={styles.headerActions}>
        <div className={styles.menuWrap}>
          <button
            ref={menuTriggerRef}
            type="button"
            className={styles.menuTrigger}
            onClick={onMenuToggle}
            aria-haspopup="menu"
            aria-expanded={menuOpen}
            aria-label="Board menu"
          >
            <MoreHorizontal size={20} />
          </button>
          <BoardMenu
            open={menuOpen}
            onClose={onMenuClose}
            triggerRef={menuTriggerRef}
            archiveCount={archiveCount}
            showDeleteBoard={showDeleteBoard}
            onChangeBackground={onChangeBackground}
            onChangeTextColor={onChangeTextColor}
            onShowMembers={onShowMembers}
            onShowArchived={onShowArchived}
            onDeleteBoard={onDeleteBoard}
          />
        </div>
      </div>
    </div>
  );
}
